import { render, staticRenderFns } from "./EmploymentHolidaysReportTableRow.vue?vue&type=template&id=2db8a018"
import script from "./EmploymentHolidaysReportTableRow.vue?vue&type=script&lang=js"
export * from "./EmploymentHolidaysReportTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports